import styled from "styled-components"
import Img from "gatsby-image"

export const MapLink = styled.a`
  width: 100%;
`

export const MapImage = styled(Img)`
  width: 100%;
`